import React from 'react';
import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages';
import AtlassianIntelligenceIcon from '@atlaskit/icon/core/atlassian-intelligence';
import sharedMessages from '@atlassian/generative-ai-modal/utils/messages';
import { createInsertAtCurrentPosition, createInsertBelow, createReplace } from '../../actions/create-actions';
import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
export var createFreeGenerateEditorAgentConfigItem = function createFreeGenerateEditorAgentConfigItem(agent) {
  return {
    key: CONFIG_ITEM_KEYS.FREE_GENERATE_EDITOR_AGENT,
    title: sharedMessages.aiButtonTitle,
    description: sharedMessages.aiUniversalLongCallToAction,
    promptHint: aiConfigItemMessages.freeGeneratePromptHint,
    icon: function icon() {
      return /*#__PURE__*/React.createElement(AtlassianIntelligenceIcon, {
        label: "",
        spacing: "spacious"
      });
    },
    doNotHighlightDocWhenSelectionIsEmpty: true,
    quickInsertPriority: Number.NEGATIVE_INFINITY,
    canTogglePageKnowledge: false,
    disableInterrogation: function disableInterrogation() {
      return false;
    },
    agent: agent,
    intentSchemaId: 'DISABLED',
    actions: {
      empty: [createInsertAtCurrentPosition({
        appearance: 'primary'
      })],
      selection: [createInsertBelow({
        appearance: 'secondary'
      }), createReplace({
        appearance: 'primary'
      })]
    },
    getBackendModel: function getBackendModel() {
      return 'assistance-service';
    }
  };
};